import axios from "axios"
import { DadosRetrospectiva } from "../pages/ResultadosFimDeAno/context/RetrospectivaContext"
import { RegistrarLogErro } from "./clientefiel"

const url = "https://d0l1xzoqn6.execute-api.us-east-1.amazonaws.com/api"

const apiLambdaRetrospectiva = axios.create({
    baseURL: url,
})

type Error = { retornoErro: number; mensagem: string }

function tratamentoResponse(response: any, chamada: string) {
    if (response.data.codErro > 0)
        return { retornoErro: response.data.codErro, mensagem: response.data.mensagem }
    else if (typeof response.data == "string" && response.data != "")
        return {
            retornoErro: 1,
            mensagem: chamada + " - Erro inesperado, entre em contato com os reponsáveis.",
        }
    else return response.data
}

const ErroRequisicao = (data: any) => {
    try {
        console.log("ErroRequisicao> ", data.request, data.message)

        if (data.message === "Network Error") {
            return "Verifique sua conexão!"
        }

        if (data.request && data.request.responseText) {
            const resposta = JSON.parse(data.request.responseText)
            return resposta.mensagem || "Erro desconhecido!"
        }

        return "Erro inesperado na requisição!"
    } catch (error) {
        RegistrarLogErro(error, "ErroRequisicao", data)
        return "Erro ao tratar requisição!"
    }
}

export const buscarDadosRetrospectiva = async (
    b64: string
): Promise<DadosRetrospectiva | Error> => {
    try {
        const url = `/retrospectiva/buscar?b64=${b64}`
        const headers = {
            "Content-Type": "application/json",
        }

        const response = await apiLambdaRetrospectiva.get(url, { headers: headers })

        return tratamentoResponse(response, "Retrospectiva")
    } catch (error) {
        const erro = ErroRequisicao(error)
        RegistrarLogErro(error, "retrospectiva")
        return { retornoErro: 1, mensagem: erro }
    }
}
